import { render, staticRenderFns } from "./ServiceTop.vue?vue&type=template&id=6450f330&scoped=true"
import script from "./ServiceTop.vue?vue&type=script&lang=js"
export * from "./ServiceTop.vue?vue&type=script&lang=js"
import style0 from "./ServiceTop.vue?vue&type=style&index=0&id=6450f330&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450f330",
  null
  
)

export default component.exports